module.exports = __webpack_public_path__ + "static/media/slack-logo.cd0c7894.png";